import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { routes } from '../../config/constants';
import Room from '../room';
import tokenManager from '../../lib/token-manager';

const ProtectedRoute = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            if (!(await tokenManager.isTokenValid())) {
                navigate(routes.signin);
            } else {
                setLoading(false);
            }
        };
        checkAuth();
    }, [navigate]);
    if (loading) {
        return null;
    }
    return (
        <Routes>
            <Route path="*" element={<Room />} />
        </Routes>
    );
};

export default ProtectedRoute;
